import { Link as RouterLink } from 'react-router-dom';
import { Link } from "@/components/common/Link";
import { Activity, ArrowRight, ArrowUpRight, FileText, Info, MapPin, Phone, Shield } from "lucide-react";
export default function FooterSection() {
  const serviceLinks = [{
    label: "Physiotherapy",
    to: "https://physanalytica.com/"
  }, {
    label: "Massage and recovery",
    to: "https://physanalytica.com/recovery-massage/"
  }, {
    label: "Gait and balance assessment",
    to: "https://physanalytica.com/gait-balance-assessment/"
  }, {
    label: "Specialist biomechanics",
    to: "https://physanalytica.com/biomechanics-expertise/"
  }, {
    label: "Precision orthotics",
    to: "https://physanalytica.com/custom-3d-printed-orthotics/"
  }, {
    label: "VO₂ Max & Metabolic Testing",
    to: "https://physanalytica.com/vo2-max-metabolic-testing/"
  }, {
    label: "Longevity & Fitness",
    to: "https://physanalytica.com/longevity-fitness/"
  }];
  const locationLinks = [{
    label: "Harrow Lodge, Hornchurch",
    to: "https://physanalytica.com/harrow-lodge-clinic/"
  }, {
    label: "Batchwood, St Albans",
    to: "https://physanalytica.com/st-albans-clinic/"
  }, {
    label: "London clinical spaces",
    to: "https://physanalytica.com/london-clinical-spaces/"
  }, {
    label: "Workplace services",
    to: "https://physanalytica.com/workplace-clinics/"
  }];
  const informationLinks = [{
    label: "About PhysAnalytica",
    to: "https://physanalytica.com/about/"
  }, {
    label: "Corporate healthcare",
    to: "https://physanalytica.com/corporate-wellness/"
  }, {
    label: "Contact",
    to: "https://physanalytica.com/contact/"
  }, {
    label: "Privacy",
    to: "https://physanalytica.com/privacy-policy/"
  }, {
    label: "Terms",
    to: "https://physanalytica.com/terms-of-service/"
  }];
  return <footer className="relative bg-slate-950 text-slate-100 overflow-hidden border-t border-slate-800/80">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_-20%,rgba(16,185,129,0.12),rgba(255,255,255,0))]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pt-16 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-14 border-b border-slate-800/80">
          <div className="lg:col-span-5 space-y-6">
            <Link to="https://physanalytica.com/" className="inline-flex items-center gap-3.5 group">
              <div className="h-11 w-11 rounded-xl bg-white/10 backdrop-blur-md p-2 flex items-center justify-center ring-1 ring-white/20 group-hover:ring-emerald-400/50 transition-all duration-300">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1754222/img/Phys-analytica-Logo-without-wording-1.png" alt="PhysAnalytica Logo" className="w-full h-auto object-contain" />
              </div>
              <div className="flex items-baseline tracking-tight font-black text-2xl sm:text-3xl">
                <span className="text-sky-400">Phys</span>
                <span className="text-emerald-400">Analytica</span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm sm:text-base leading-relaxed max-w-md font-normal">
              Physiotherapy, Biomechanics and Movement Healthcare. Dedicated clinical precision and evidence-based assessment for elite movement, daily recovery, and corporate wellness.
            </p>
            <div className="flex items-start gap-2">
              <MapPin className="w-3.5 h-3.5 text-emerald-400 shrink-0 mt-0.5" />
              <span className="text-slate-400 text-sm sm:text-base leading-relaxed">
                Harrow Lodge Leisure Centre, Hornchurch Road, Hornchurch, RM11 1JU
              </span>
            </div>
            <p className="text-slate-400 text-xs sm:text-sm leading-relaxed">
              Hornchurch • St Albans • Selected London Clinical Spaces
            </p>
            <div className="pt-2 flex flex-wrap items-center gap-3">
              <RouterLink to="tel:07916538694" className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg bg-slate-900 border border-slate-800 text-slate-300 text-xs font-medium hover:text-emerald-400 hover:border-emerald-500/40 transition-colors">
                <Phone className="w-3.5 h-3.5 text-emerald-400" />
                07916 538694
              </RouterLink>
              <Link to="https://physanalytica.com/book-now/" className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg bg-slate-900 border border-slate-800 text-slate-300 text-xs font-medium hover:text-sky-400 hover:border-sky-500/40 transition-colors">
                Book an Appointment
                <ArrowRight className="w-3.5 h-3.5 text-sky-400" />
              </Link>
            </div>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-6">
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-xs font-semibold tracking-wider text-emerald-400 uppercase">
                <Activity className="w-3.5 h-3.5" />
                SERVICES
              </div>
              <ul className="space-y-2.5">
                {serviceLinks.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="group inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors duration-150">
                      <span className="group-hover:translate-x-0.5 transition-transform duration-150">{item.label}</span>
                      <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 group-hover:opacity-100 transition-all text-emerald-400" />
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-xs font-semibold tracking-wider text-sky-400 uppercase">
                <MapPin className="w-3.5 h-3.5" />
                LOCATIONS
              </div>
              <ul className="space-y-2.5">
                {locationLinks.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="group inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors duration-150">
                      <span className="group-hover:translate-x-0.5 transition-transform duration-150">{item.label}</span>
                      <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 group-hover:opacity-100 transition-all text-sky-400" />
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-xs font-semibold tracking-wider text-slate-300 uppercase">
                <Info className="w-3.5 h-3.5" />
                INFORMATION
              </div>
              <ul className="space-y-2.5">
                {informationLinks.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="group inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors duration-150">
                      <span className="group-hover:translate-x-0.5 transition-transform duration-150">{item.label}</span>
                      <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 group-hover:opacity-100 transition-all text-slate-300" />
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p className="text-center md:text-left">
            © PhysAnalytica Ltd · Physiotherapy, Biomechanics and Movement Healthcare
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-slate-400">
            <Link to="https://physanalytica.com/privacy-policy/" className="hover:text-slate-200 transition-colors inline-flex items-center gap-1">
              <Shield className="w-3 h-3" />
              Privacy
            </Link>
            <span>·</span>
            <Link to="https://physanalytica.com/terms-of-service/" className="hover:text-slate-200 transition-colors inline-flex items-center gap-1">
              <FileText className="w-3 h-3" />
              Terms
            </Link>
            <span>·</span>
            <RouterLink to="tel:07916538694" className="hover:text-emerald-400 transition-colors">
              07916 538694
            </RouterLink>
            <span>·</span>
            <Link to="https://www.physanalytica.com/" className="hover:text-sky-400 transition-colors">
              www.physanalytica.com
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}